// angular
import { NgClass } from '@angular/common';
import { Component, input } from '@angular/core';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

@Component({
  selector: 'pwj-auction-card-skeleton',
  standalone: true,
  imports: [NgxSkeletonLoaderModule, NgClass],
  templateUrl: './auction-card-skeleton.component.html',
  styleUrl: './auction-card-skeleton.component.scss',
  host: {
    '[class.auction-card-skeleton-host--list]': 'wrapInListItem()',
  },
})
export class AuctionCardSkeletonComponent {
  count = input<number>(1);
  wrapInListItem = input<boolean>(false);
  containerClasses = input<string>('');

  public counter(i: number) {
    return new Array(i);
  }
}
